const PREFIX = 'vrGameChat:';

export function chatStorageKey(playerId, characterId) {
  return `${PREFIX}${String(playerId || '').trim()}:${String(characterId || '').trim()}`;
}

export function loadChatMessages(playerId, characterId) {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(chatStorageKey(playerId, characterId));
    if (!raw) return [];
    const data = JSON.parse(raw);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export function saveChatMessages(playerId, characterId, messages) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(chatStorageKey(playerId, characterId), JSON.stringify(messages));
  } catch {
    /* ignore quota */
  }
}
